(function() {
    taillightUx.factory('$tuxConstant', TuxConstantFactory);

    function TuxConstantFactory() {

        return {
            KEY_CODE: {
                ENTER: 13,
                ESCAPE: 27,
                SPACE: 32,
                LEFT_ARROW: 37,
                UP_ARROW: 38,
                RIGHT_ARROW: 39,
                DOWN_ARROW: 40,
                TAB: 9,
                BACKSPACE: 8,
                DELETE: 46,
                SHIFT: 16,
                CTRL: 17,
                ALT: 18,
                PAUSE: 19,
                CAPSLOCK: 20,
                LEFT_VENDOR_KEY: 91,
                RIGHT_VENDOR_KEY: 92,
                SELECT: 93,
                PERIOD: 110,
                DECIMAL_POINT: 190
            }
        }
    }

})();